import Script from 'next/script';
import getConfig from 'next/config';

import { bugsnag } from 'shared/utils/services/bugsnag';

interface IGoogleAWTagScriptProps {
  cspNonce: string;
  isOneTrustEnabled: boolean;
}

export const GoogleAWTagScript = ({ cspNonce, isOneTrustEnabled }: IGoogleAWTagScriptProps) => {
  const { publicRuntimeConfig } = getConfig();
  const { GOOGLE_AW_CONVERSION_ID }: { GOOGLE_AW_CONVERSION_ID: string } = publicRuntimeConfig;

  /**
   * NOTE: if one trust is not enabled, then will initialize GTM here otherwise
   * will be initialized within the one trust script within their internally
   * callback function to ensure that the script is correctly blocked.
   */
  return (
    <>
      {!isOneTrustEnabled && (
        <Script
          id="g-aw-script-1"
          key="gtag"
          onError={(error) => {
            bugsnag(error, { context: 'Google AW Tag Manager Script Erroring' });
          }}
          src={`https://www.googletagmanager.com/gtag/js?id=${GOOGLE_AW_CONVERSION_ID}`}
        />
      )}
      <Script
        id="g-aw-script-2"
        key="gtagConversion"
        type={isOneTrustEnabled ? 'text/plain' : 'text/javascript'}
        className="optanon-category-C0004"
        nonce={cspNonce}
        onError={(error) => {
          bugsnag(error, { context: 'Google AW Tag Conversion Script Erroring' });
        }}
      >
        {`
          window.dataLayer = window.dataLayer || [];
          window.gtag = (...args) => {
            window.dataLayer.push(...args);
          };
          window.gtag('js', new Date());
          window.gtag('config', '${GOOGLE_AW_CONVERSION_ID}');
        `}
      </Script>
    </>
  );
};
